/**
 * 대전광역시상수도사업본부 지출결의서 — 누름틀 fieldId ↔ 결의 컬럼
 * SSOT: D:\295\erp\BD\design\15_지출결의서_양식필드매핑.md
 *
 * 누름틀 name = fieldId. HWP에는 표시 문자열, DB에는 코드/원/일자.
 */

export const FORM_ID_DJ_WATERWORKS_V1 = 'form-dj-waterworks-v1';

/** 지급·송금 표시 */
export const PAY_METHOD = {
  PAY: 'PAY',
  TRANSFER: 'TRANSFER',
};

export const PAY_METHOD_LABEL = {
  PAY: '지급',
  TRANSFER: '송금',
};

/**
 * 기준 양식 필드 정의
 * - lookupGroup: 같은 그룹은 팝업 1회로 묶음 주입
 * - syncToDb: 저장 시 정규 컬럼 반영
 */
export const DJ_WATERWORKS_V1_FIELDS = [
  // 머리글
  { fieldId: 'doc.evidenceNo', label: '증제번호', input: 'system', target: 'master', column: 'resolutionNo', type: 'string', syncToDb: true, guide: '결의번호' },
  { fieldId: 'header.deptName', label: '부서명', input: 'lookupDept', lookupGroup: 'dept', target: 'master', column: 'deptName', codeColumn: 'deptCode', type: 'string', syncToDb: true, guide: '부서명' },
  { fieldId: 'header.fiscalYear', label: '회계연도', input: 'system', target: 'master', column: 'fiscalYear', type: 'string', syncToDb: true, guide: '년도' },
  { fieldId: 'header.orgName', label: '조직명', input: 'system', target: 'master', column: 'orgName', type: 'string', syncToDb: true, guide: '기관명' },

  // 결재란 — 1차 문서 전용
  { fieldId: 'sign.officer', label: '담당자', input: 'stamp', target: '—', syncToDb: false, guide: '담당자' },
  { fieldId: 'sign.manager', label: '담당', input: 'stamp', target: '—', syncToDb: false, guide: '담당' },
  { fieldId: 'sign.sectionChief', label: '과장', input: 'stamp', target: '—', syncToDb: false, guide: '과장' },
  { fieldId: 'sign.corpCashier', label: '기업출납원', input: 'stamp', target: '—', syncToDb: false, guide: '기업출납원' },
  { fieldId: 'sign.handler', label: '취급자', input: 'stamp', target: '—', syncToDb: false, guide: '취급자' },
  { fieldId: 'sign.disbursementOfficer', label: '지출원', input: 'stamp', target: '—', syncToDb: false, guide: '지출원' },

  // 세출과목
  { fieldId: 'subject.gwan', label: '관', input: 'lookupSubject', lookupGroup: 'subject', target: 'master', column: 'gwanName', codeColumn: 'gwanCode', type: 'nameCode', syncToDb: true, guide: '관' },
  { fieldId: 'subject.hang', label: '항', input: 'lookupSubject', lookupGroup: 'subject', target: 'master', column: 'hangName', codeColumn: 'hangCode', type: 'nameCode', syncToDb: true, guide: '항' },
  { fieldId: 'subject.sehang', label: '세항', input: 'lookupSubject', lookupGroup: 'subject', target: 'master', column: 'sehangName', codeColumn: 'sehangCode', type: 'nameCode', syncToDb: true, guide: '세항' },
  { fieldId: 'subject.mok', label: '목', input: 'lookupSubject', lookupGroup: 'subject', target: 'master', column: 'mokName', codeColumn: 'mokCode', type: 'nameCode', syncToDb: true, guide: '목' },
  { fieldId: 'subject.semok', label: '세목', input: 'lookupSubject', lookupGroup: 'subject', target: 'master', column: 'subjectName', codeColumn: 'subjectCode', type: 'nameCode', syncToDb: true, guide: '세목', also: { semokName: 'name', semokCode: 'code' } },

  // 사업
  { fieldId: 'project.policy', label: '정책', input: 'lookupProject', lookupGroup: 'project', target: 'master', column: 'policyName', codeColumn: 'policyCode', type: 'nameCode', syncToDb: true, guide: '정책' },
  { fieldId: 'project.unit', label: '단위', input: 'lookupProject', lookupGroup: 'project', target: 'master', column: 'unitName', codeColumn: 'unitCode', type: 'nameCode', syncToDb: true, guide: '단위' },
  { fieldId: 'project.detail', label: '세부', input: 'lookupProject', lookupGroup: 'project', target: 'master', column: 'projectName', codeColumn: 'projectCode', type: 'nameCode', syncToDb: true, guide: '세부', also: { detailName: 'name', detailCode: 'code' } },

  // 좌측 프로세스
  { fieldId: 'process.proposeDate', label: '발의', input: 'manual', target: 'master', column: 'proposeDate', type: 'date', syncToDb: true, guide: '발의일자' },
  { fieldId: 'process.contractDate', label: '계약', input: 'manual', target: 'master', column: 'contractDate', type: 'date', syncToDb: true, guide: '계약일자' },
  { fieldId: 'process.obligationLedgerDate', label: '원인행위액등기', input: 'system', target: 'master', stampKey: 'obligationLedgerDate', type: 'date', syncToDb: true, guide: '원인행위액등기' },
  { fieldId: 'process.inspectDate', label: '검수', input: 'manual', target: 'master', column: 'inspectDate', type: 'date', syncToDb: true, guide: '검수일자' },
  { fieldId: 'process.budgetControlDebtDate', label: '채무확정액등기', input: 'system', target: 'master', stampKey: 'budgetControlDebtDate', type: 'date', syncToDb: true, guide: '지출예산통제원장채무확정액등기' },
  { fieldId: 'process.debtCostJournalDate', label: '원가분개장등기', input: 'system', target: 'master', stampKey: 'debtCostJournalDate', type: 'date', syncToDb: true, guide: '채무확정 및 원가분개장등기' },

  // 우측 지급
  { fieldId: 'payment.proposeDate', label: '지급발의', input: 'manual', target: 'master', column: 'paymentProposeDate', type: 'date', syncToDb: true, guide: '발의일자' },
  { fieldId: 'payment.budgetControlLedgerDate', label: '통제원장등기', input: 'system', target: 'master', stampKey: 'budgetControlLedgerDate', type: 'date', syncToDb: true, guide: '지출예산통제원장 등기' },
  { fieldId: 'payment.fundLedgerDate', label: '자금지출부등기', input: 'system', target: 'master', stampKey: 'fundLedgerDate', type: 'date', syncToDb: true, guide: '자금지출부 등기' },
  { fieldId: 'payment.orderNo', label: '지급명령번호', input: 'system', target: 'master', column: 'paymentOrderNo', type: 'string', syncToDb: true, guide: '지급명령번호' },

  // 금액 — 팝업 5칸(총지급액·공급가·부가세·수수료·계). 양식에는 총지급액 제외 4칸
  { fieldId: 'amount.total', label: '계', input: 'amountGroup', target: 'both', column: 'resolutionAmt', detailColumn: 'amount', type: 'amount', syncToDb: true, guide: '금 원' },
  { fieldId: 'amount.supply', label: '공급가액', input: 'amountGroup', target: 'master', column: 'supplyAmt', type: 'amount', syncToDb: true, guide: '공급가액' },
  { fieldId: 'amount.vat', label: '부가가치세', input: 'amountGroup', target: 'detail', detailColumn: 'vatAmt', type: 'amount', syncToDb: true, guide: '부가가치세' },
  { fieldId: 'amount.fee', label: '기타 수수료', input: 'amountGroup', target: 'master', column: 'feeAmt', type: 'amount', syncToDb: true, guide: '기타 수수료' },

  // 적요·채주·영수·계좌
  { fieldId: 'remark', label: '적요', input: 'manual', target: 'master', column: 'remark', type: 'string', syncToDb: true, guide: '적요' },
  { fieldId: 'payee.address', label: '채주 주소', input: 'lookupVendor', lookupGroup: 'vendor', target: 'detail', detailColumn: 'vendorAddress', type: 'string', syncToDb: true, guide: '주소' },
  { fieldId: 'payee.bizName', label: '채주 상호', input: 'lookupVendor', lookupGroup: 'vendor', target: 'detail', detailColumn: 'vendorName', type: 'string', syncToDb: true, guide: '상호' },
  { fieldId: 'payee.name', label: '채주 성명', input: 'lookupVendor', lookupGroup: 'vendor', target: 'detail', detailColumn: 'vendorCeoName', type: 'string', syncToDb: true, guide: '성명' },
  { fieldId: 'receipt.date', label: '영수일자', input: 'manual', target: 'master', column: 'receiptDate', type: 'date', syncToDb: true, guide: '영수일자' },
  { fieldId: 'receipt.name', label: '영수 성명', input: 'manual', target: 'master', column: 'receiptName', type: 'string', syncToDb: true, guide: '영수인' },
  { fieldId: 'bank.accountDisplay', label: '거래은행 계좌번호', input: 'lookupVendorAccount', lookupGroup: 'vendorAccount', target: 'detail', type: 'accountDisplay', syncToDb: true, guide: '거래은행 계좌번호' },
  { fieldId: 'pay.method', label: '지급·송금', input: 'manual', target: 'master', column: 'payMethod', type: 'payMethod', syncToDb: true, guide: '지급 · 송금' },
  { fieldId: 'sign.disburseDate', label: '지출원 일자', input: 'system', target: 'master', column: 'disburseConfirmDate', type: 'date', syncToDb: true, guide: '지출원일자' },
];

export const DJ_WATERWORKS_V1_FORM = {
  formId: FORM_ID_DJ_WATERWORKS_V1,
  formName: '대전광역시상수도사업본부 지출결의서',
  publicUrl: '/samples/expense-resolution/form-dj-waterworks-v1.hwp',
  sourceUrl: '/samples/expense-resolution/form-dj-waterworks-src.hwp',
  fields: DJ_WATERWORKS_V1_FIELDS,
  subjectLeafField: 'subject.semok',
  projectLeafField: 'project.detail',
};

function asStr(v) {
  return v == null ? '' : String(v).trim();
}

/** `사업비용(700)` → { name, code } */
export function parseNameCode(text) {
  const raw = asStr(text);
  const m = raw.match(/^(.*)\(([^)]+)\)\s*$/);
  if (m) return { name: m[1].trim(), code: m[2].trim() };
  return { name: raw, code: '' };
}

export function formatNameCode(name, code) {
  const n = asStr(name);
  const c = asStr(code);
  if (n && c) return `${n}(${c})`;
  return n || c;
}

/** 금 1,234 원 → 정수 원 */
export function parseAmount(text) {
  const raw = asStr(text).replace(/금/g, '').replace(/원/g, '').replace(/,/g, '').replace(/\s/g, '');
  if (!raw) return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? Math.round(n) : 0;
}

export function formatAmount(n) {
  const v = Number(n) || 0;
  return `금 ${v.toLocaleString('ko-KR')} 원`;
}

/** 부가세 포함가 → 공급가·부가세 (10%, 원단위 반올림) */
export function splitVatInclusive(taxableWon) {
  const n = Math.max(0, Math.round(Number(taxableWon) || 0));
  if (n === 0) return { supplyAmt: 0, vatAmt: 0 };
  const vatAmt = Math.round(n / 11);
  return { supplyAmt: n - vatAmt, vatAmt };
}

/**
 * 금액 5칸 계산
 * - 총 지급액(payTotalAmt): 입력. 공급가+부가세
 * - 공급가·부가세: 총 지급액을 부가세 포함 10% 역산
 * - 수수료: 입력. 총 지급액에 포함되지 않음
 * - 계: 입력 없음. 계 = 총 지급액 + 수수료
 * 양식 반영은 총 지급액 제외 4칸(계·공급가·부가세·수수료)
 */
export function reconcileResolutionAmounts({
  payTotalAmt = 0,
  fee = 0,
  supply = 0,
  vat = 0,
  total = 0,
} = {}) {
  const f = Math.max(0, Math.round(Number(fee) || 0));
  let pay = Math.max(0, Math.round(Number(payTotalAmt) || 0));
  if (!pay) {
    const fromSplit = Math.max(0, Math.round((Number(supply) || 0) + (Number(vat) || 0)));
    if (fromSplit) pay = fromSplit;
  }
  if (!pay) {
    const t = Math.max(0, Math.round(Number(total) || 0));
    pay = Math.max(0, t - f);
  }
  const { supplyAmt, vatAmt } = splitVatInclusive(pay);
  return { payTotalAmt: pay, fee: f, supply: supplyAmt, vat: vatAmt, total: pay + f };
}

/** 양식 누름틀용 — 총 지급액은 팝업 전용이라 넣지 않음 */
export function amountPartsToFieldValues(parts) {
  return {
    'amount.total': formatAmount(parts.total),
    'amount.supply': formatAmount(parts.supply),
    'amount.vat': formatAmount(parts.vat),
    'amount.fee': formatAmount(parts.fee),
  };
}

export function parseDate(text) {
  const raw = asStr(text);
  if (!raw) return '';
  const kor = raw.match(/(\d{4})\s*년\s*(\d{1,2})\s*월\s*(\d{1,2})\s*일/);
  if (kor) {
    const y = kor[1];
    const m = String(kor[2]).padStart(2, '0');
    const d = String(kor[3]).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  return raw;
}

export function formatDate(ymd) {
  const raw = asStr(ymd);
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 8) return raw;
  return `${digits.slice(0, 4)}년 ${Number(digits.slice(4, 6))}월 ${Number(digits.slice(6, 8))}일`;
}

export function parseAccountDisplay(text) {
  const raw = asStr(text);
  if (!raw) return { bankName: '', accountNo: '', accountHolder: '' };
  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return { bankName: '', accountNo: parts[0], accountHolder: '' };
  if (parts.length === 2) return { bankName: parts[0], accountNo: parts[1], accountHolder: '' };
  return {
    bankName: parts[0],
    accountNo: parts[1],
    accountHolder: parts.slice(2).join(' '),
  };
}

export function formatAccountDisplay(bankName, accountNo, accountHolder) {
  return [asStr(bankName), asStr(accountNo), asStr(accountHolder)].filter(Boolean).join(' ');
}

export function parsePayMethod(text) {
  const raw = asStr(text);
  if (!raw) return '';
  if (raw.includes('송금') && !raw.includes('지급')) return PAY_METHOD.TRANSFER;
  if (raw.includes('지급') && !raw.includes('송금')) return PAY_METHOD.PAY;
  if (raw === PAY_METHOD.TRANSFER || raw === PAY_METHOD.PAY) return raw;
  return raw;
}

export function formatPayMethod(code) {
  const c = asStr(code);
  if (c === PAY_METHOD.TRANSFER) return '송금';
  if (c === PAY_METHOD.PAY) return '지급';
  return c;
}

function fieldById(fieldId) {
  return DJ_WATERWORKS_V1_FIELDS.find((f) => f.fieldId === fieldId);
}

function parseByType(field, text) {
  const t = field.type || 'string';
  if (t === 'amount') return parseAmount(text);
  if (t === 'date') return parseDate(text);
  if (t === 'nameCode') return parseNameCode(text);
  if (t === 'accountDisplay') return parseAccountDisplay(text);
  if (t === 'payMethod') return parsePayMethod(text);
  return asStr(text);
}

function formatByType(field, master, detail) {
  const t = field.type || 'string';
  if (t === 'nameCode') {
    const name = field.column ? master[field.column] : '';
    const code = field.codeColumn ? master[field.codeColumn] : '';
    return formatNameCode(name, code);
  }
  if (t === 'amount') {
    if (field.target === 'detail' || field.detailColumn) {
      return formatAmount(detail?.[field.detailColumn]);
    }
    return formatAmount(master[field.column]);
  }
  if (t === 'date') {
    if (field.stampKey) {
      const stamps = master.processStampJson && typeof master.processStampJson === 'object'
        ? master.processStampJson
        : {};
      return formatDate(stamps[field.stampKey]);
    }
    return formatDate(master[field.column]);
  }
  if (t === 'accountDisplay') {
    return formatAccountDisplay(detail?.bankName, detail?.accountNo, detail?.accountHolder);
  }
  if (t === 'payMethod') return formatPayMethod(master.payMethod);
  if (field.target === 'detail' && field.detailColumn) return asStr(detail?.[field.detailColumn]);
  if (field.column) return asStr(master[field.column]);
  return '';
}

function ensureStampJson(master) {
  if (master.processStampJson && typeof master.processStampJson === 'object') return master.processStampJson;
  return {};
}

/**
 * 문서 필드값 → 결의 master/detail 패치
 * @param {Record<string, string>} fieldValues fieldId → HWP 텍스트
 */
export function fieldValuesToResolution(fieldValues = {}, { existingMaster = {}, existingDetail = {} } = {}) {
  const master = { ...existingMaster };
  const detail = { ...existingDetail };
  const stamps = { ...ensureStampJson(master) };

  DJ_WATERWORKS_V1_FIELDS.forEach((field) => {
    if (!field.syncToDb) return;
    const raw = fieldValues[field.fieldId];
    if (raw == null) return;
    const parsed = parseByType(field, raw);

    if (field.stampKey) {
      stamps[field.stampKey] = typeof parsed === 'string' ? parsed : asStr(raw);
      return;
    }
    if (field.type === 'nameCode') {
      if (field.column) master[field.column] = parsed.name;
      if (field.codeColumn) master[field.codeColumn] = parsed.code;
      if (field.also) {
        if (field.also.semokName) master.semokName = parsed.name;
        if (field.also.semokCode) master.semokCode = parsed.code;
        if (field.also.detailName) master.detailName = parsed.name;
        if (field.also.detailCode) master.detailCode = parsed.code;
      }
      return;
    }
    if (field.type === 'accountDisplay') {
      detail.bankName = parsed.bankName;
      detail.accountNo = parsed.accountNo;
      detail.accountHolder = parsed.accountHolder;
      return;
    }
    if (field.target === 'detail' && field.detailColumn) {
      detail[field.detailColumn] = parsed;
      if (field.detailColumn === 'vatAmt') {
        detail.vatYn = Number(parsed) > 0 ? 'Y' : 'N';
      }
      return;
    }
    if (field.target === 'both') {
      master[field.column] = parsed;
      if (field.detailColumn) detail[field.detailColumn] = parsed;
      return;
    }
    if (field.column) master[field.column] = parsed;
  });

  master.processStampJson = stamps;
  return { master, detail };
}

/**
 * 결의 master/detail → PutFieldText 용 맵
 */
export function resolutionToFieldValues(master = {}, detail = {}) {
  const out = {};
  DJ_WATERWORKS_V1_FIELDS.forEach((field) => {
    if (field.input === 'stamp' && !field.syncToDb) {
      out[field.fieldId] = '';
      return;
    }
    out[field.fieldId] = formatByType(field, master, detail);
  });
  return out;
}

/**
 * 과목 팝업 1건 → 관~세목 필드 텍스트
 * chain: [{ levelName, subjectCode, subjectName }, ...] 상위→리프
 */
export function subjectChainToFieldValues(chain = []) {
  const byLevel = {};
  (chain || []).forEach((row) => {
    const lv = asStr(row.levelName);
    if (lv) byLevel[lv] = row;
  });
  const pick = (level) => {
    const row = byLevel[level];
    if (!row) return '';
    return formatNameCode(row.subjectName, row.subjectCode);
  };
  return {
    'subject.gwan': pick('관'),
    'subject.hang': pick('항'),
    'subject.sehang': pick('세항'),
    'subject.mok': pick('목'),
    'subject.semok': pick('세목') || pick('목') || '',
  };
}

/**
 * 사업 팝업 1건 → 정책·단위·세부 필드 텍스트
 */
export function projectChainToFieldValues(chain = []) {
  const byLevel = {};
  (chain || []).forEach((row) => {
    const lv = asStr(row.levelName);
    if (lv) byLevel[lv] = row;
  });
  const pick = (level) => {
    const row = byLevel[level];
    if (!row) return '';
    return formatNameCode(row.projectName || row.subjectName, row.projectCode || row.subjectCode);
  };
  return {
    'project.policy': pick('정책'),
    'project.unit': pick('단위'),
    'project.detail': pick('세부') || pick('단위') || pick('정책') || '',
  };
}

/**
 * 거래처+주계좌 → 채주·계좌 필드 (HWP)
 * vendorCode 는 양식 칸이 없으므로 호출측에서 detail 에 같이 넣는다.
 */
export function vendorToFieldValues(vendor = {}, account = {}) {
  return {
    'payee.address': asStr(vendor.address),
    'payee.bizName': asStr(vendor.vendorName),
    'payee.name': asStr(vendor.ceoName),
    'bank.accountDisplay': formatAccountDisplay(account.bankName, account.accountNo, account.accountHolder),
  };
}

/** 거래처 팝업 결과 → detail 패치 (코드 포함) */
export function vendorToDetailPatch(vendor = {}, account = {}) {
  return {
    vendorCode: asStr(vendor.vendorCode),
    vendorName: asStr(vendor.vendorName),
    vendorAddress: asStr(vendor.address),
    vendorCeoName: asStr(vendor.ceoName),
    bankName: asStr(account.bankName),
    accountNo: asStr(account.accountNo),
    accountHolder: asStr(account.accountHolder),
  };
}

export function fieldsForLookupGroup(group) {
  return DJ_WATERWORKS_V1_FIELDS.filter((f) => f.lookupGroup === group);
}

export function getFieldDef(fieldId) {
  return fieldById(fieldId) || null;
}

/** 코드 트리 상위→현재 체인 (과목·사업 팝업 1건 → 여러 칸) */
export function walkCodeChain(row, allRows = [], { codeKey, parentKey } = {}) {
  const ck = codeKey || 'subjectCode';
  const pk = parentKey || 'parentCode';
  const byCode = new Map();
  (allRows || []).forEach((r) => {
    const c = String(r?.[ck] || '').trim();
    if (c) byCode.set(c, r);
  });
  const chain = [];
  let cur = row;
  let guard = 0;
  while (cur && guard++ < 24) {
    chain.unshift(cur);
    const p = String(cur?.[pk] || '').trim();
    if (!p) break;
    cur = byCode.get(p) || null;
  }
  return chain;
}
